import React, { Component } from "react";
import {
    message,
    PageHeader,
    Spin,
    Row,
    Col,
    Select,
    Upload,
    Space,
    Tooltip,
    Tag,
    Radio
} from "antd";
import {
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    DatePickerItem,
    ButtonItem,
    InputItem,
    TextAreaItem,
    ModalItem,
    SelectInsumosItem,
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import ElegirTipoDeCliente from "../../Clientes/ElegirTipoDeCliente/ElegirTipoDeCliente";
import AgregarMarbetes from "../../Marbetes/AgregarMarbetes/AgregarMarbetes";
import MandarCorreoComodato from "../MandarCorreoComodato/MandarCorreoComodato";
import VerLotes from "../../LotesCaducidades/VerLotes/VerLotes";
import { DeleteOutlined, EyeOutlined, UploadOutlined, DatabaseOutlined,TagsOutlined } from "@ant-design/icons";

const { Option } = Select;

moment.locale("es");


function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

class VerOrdenComodato extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        tipoEntidad: 'cliente',
        objetoClientes: null,
        todasClientes: null,
        objetoProveedores: null,
        todasProveedores: null,
        objetoProyectos: null,
        todasProyectos: null,
        objetoInsumos: (
            <Option disabled value={0} key={0}>
                Seleccione un proveedor primero
            </Option>
        ),
        todasInsumos: [],
        modalConfirmacion: false,
        valuesForm: null,
        modalElegirTipoDeCliente: false,
        modalElegirTipoDeClienteId: null,
        modalElegirTipoDeClienteNombre: null,
        archivosXml: [],
        empresaRfc: null,
        rendered: 0,
        ajusteMax: 0,
        modalAgregarMarbetes: false,
        modalAgregarMarbetesIndex: null,
        modalAgregarMarbetesMarbetes: null,
        modalVerLotes: false,
        modalVerLotesIndex: null,
        modalVerLotesInsumoId: null,
        estadoCC: false,
        xmlFile: null,
        xmltotales: null,
        mensajeMostrado: false,
        modalMandarCorreoComodato: false,
        id: this.props?.location?.state?.id,
        archivos: [],
    };
    async componentDidMount() {
        this.setState({ loading: true });
        await this.consultarTodo()
        this.setState({ loading: false });
    }

    async consultarTodo() {

        const responseOrden = axios.post("comodato/selectDatosParaVerOrden",
            { empresaId: this.props.empresaId, ordenComodatoId: this.props?.location?.state?.id },
            { headers: this.props.headersToken });

        const responseProveedores = axios.post("proveedores/selectProveedores",
            { empresaId: this.props.empresaId },
            { headers: this.props.headersToken });

        const [resOrden, resProveedores] = await Promise.all([responseOrden, responseProveedores]);

        if (resOrden.data.success === 2) {
            const orden = resOrden.data.ordenComodato;
            const tipoEntidad = orden?.tipoEntidad || (orden?.proveedorId ? 'proveedor' : 'cliente');
            this.setState({
                tipoEntidad,
                todasInsumos: resOrden.data.insumos,
                todasClientes: resOrden.data.clientes,
                objetoClientes: resOrden.data.clientes.map((value) => (
                    <Option value={value._id} key={value._id}>
                        {value.stringBuscar}
                    </Option>
                )),
                todasProyectos: resOrden.data.proyectos,
                objetoProyectos: resOrden.data.proyectos.map((value) => (
                    <Option value={value._id} key={value._id}>
                        {value.nombre}
                    </Option>
                )),
                archivos: Array.isArray(orden?.archivos) ? orden.archivos.map(valueArch => ({
                    ...valueArch,
                    url: valueArch.url ? ((process.env.NODE_ENV === "development" ? "http://192.168.100.6:3001/../" : "../") + valueArch.url) : "",
                })) : [],
            });
            this.formRef.current.setFieldsValue({
                ...orden,
                fechaOrden: moment(orden.fechaOrden),
                fechaEntrega: moment(orden.fechaEntrega),
            });
            if (Array.isArray(orden?.insumos)) {
                orden.insumos.forEach((insumos, index) => {
                    this.onChangeInsumo(insumos.insumoId, index, insumos.insumoEncontrado);
                });
            }
        } else {
            message.error("Hubo un error al cargar los datos");
        }

        if (resProveedores.data && !resProveedores.data.status) {
            this.setState({
                todasProveedores: resProveedores.data,
                objetoProveedores: resProveedores.data.map((value) => (
                    <Option value={value._id} key={value._id}>
                        {value.stringBuscar}
                    </Option>
                )),
            });
        }

    }

    atras() {
        this.props.history.push('/panel/comodato');
    }
    async actualizarBoton() {
        await this.consultarTodo()
        let arrayValue = this.formRef.current.getFieldValue("insumos");
        if (arrayValue?.length > 0) {
            arrayValue.map((valueInsumo, key) => this.onChangePrecioCantidadDescuento(undefined, key))
        }
    }
    abrirElegirTipoDeCliente(id, nombre) {
        this.setState({ modalElegirTipoDeCliente: true, modalElegirTipoDeClienteId: id, modalElegirTipoDeClienteNombre: nombre });
    }
    cerrarElegirTipoDeCliente(elegido) {
        if (!elegido) {
            this.formRef.current.setFieldsValue({ proveedorId: undefined })
        }
        this.consultarTodo()
        this.setState({ modalElegirTipoDeCliente: false, modalElegirTipoDeClienteId: null, modalElegirTipoDeClienteNombre: null });
    }

    abrirAgregarMarbetes(value, marbetes) {
        this.setState({
            modalAgregarMarbetes: true,
            modalAgregarMarbetesIndex: value,
            modalAgregarMarbetesMarbetes: marbetes
        })
    }

    cerrarAgregarMarbetes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalAgregarMarbetesIndex].marbetes = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalAgregarMarbetes: false,
            modalAgregarMarbetesIndex: null,
            modalAgregarMarbetesMarbetes: null
        })
    }

    abrirVerLotes(value, insumoId) {
        this.setState({
            modalVerLotes: true,
            modalVerLotesIndex: value,
            modalVerLotesInsumoId: insumoId,
        })
    }

    cerrarVerLotes(value) {
        this.setState({
            modalVerLotes: false,
            modalVerLotesIndex: null,
            modalVerLotesInsumoId: null
        })
    }

    onChangeCliente(valueId) {
        const contado = this.formRef.current.getFieldValue("contado");
        const cliente = this.state.todasClientes.find(
            (valueProv) => valueProv._id === valueId
        );
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        this.formRef.current.setFieldsValue({
            diasCredito: cliente.diasCredito || 0,
            precioId:
                contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId,
            usoDeCfdiId: cliente.usoDeCFDIID,
            proyectoId: cliente.proyectoId,
        });
    }

    async onChangeInsumo(value, key, insumoEncontrado) {
        const proyectoId = await this.formRef.current.getFieldValue("proyectoId");
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        const insumoId = arrayValue[key].insumoId;
        let insumo
        if (insumoEncontrado) {
            insumo = insumoEncontrado;
            const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
            if (!yaExiste) {
            await this.setState(prev => ({
                todasInsumos: [...prev.todasInsumos, insumo]
            }));
            }
        } else {
            insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === insumoId
            );
        }
        this.setState({ loading: false });
        if (!insumo) return
        arrayValue[key].codigo = insumo.codigo
        arrayValue[key].unidad = insumo.unidad

        if (!arrayValue[key].proyectoId) {
            arrayValue[key].proyectoId = proyectoId;
        }

        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
    }

    abrirMandarCorreo() {
        this.setState({ modalMandarCorreoComodato: true });
    }

    cerrarMandarCorreoComodato() {
        this.setState({ modalMandarCorreoComodato: false });
    }

    handlePreviewArchivo = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        this.setState({
            previewImageArchivo: file.url || file.preview,
            previewVisibleArchivo: true,
            previewTitleArchivo: file.name || '',
        },);
    };

    handleCancelArchivo = () => this.setState({ previewVisibleArchivo: false });

    getInsumosColumns() {
        return [
            { title: "Codigo",   width: "10%" },
            { title: "Insumo",   width: "25%" },
            { title: "Unidad", width: "5%" },
            { title: "Proyecto", width: "20%" },
            { title: "Cantidad", width: "10%" },
            { title: "Acción",   width: "15%" },
        ];
    }

    renderInsumoRow({ key, name, fieldKey, restField, arrayKey }) {
        const insumos = this.formRef.current?.getFieldValue('insumos') || [];
        const estadoCCPrimeroAqui = insumos[arrayKey]?.estadoCC && !insumos[arrayKey - 1]?.estadoCC;

        return (
            <React.Fragment key={key}>
                {estadoCCPrimeroAqui && (
                    <tr>
                        <td className="td-border-sin-right" colSpan="12" style={{ textAlign: 'left', fontWeight: 'bold', fontSize: 20, paddingLeft: 10 }}>
                            <h1 style={{ paddingTop: 0, paddingBottom: 0 }}>Estado de Cuenta Combustibles</h1>
                        </td>
                    </tr>
                )}
                <tr>
                    {/* Codigo */}
                    <td className="td-border">
                        <FormItem
                            {...restField}
                            name={[name, "codigo"]}
                            fieldKey={[arrayKey, "codigo"]}
                            noStyle
                            disabled
                        >
                            <InputItem
                                sinBorde
                                disabled
                                autoFocus
                                style={{ width: "100%" }}
                                placeholder="Codigo"
                            />
                        </FormItem>
                    </td>
                    {/* Insumo */}
                    <td className="td-border">
                        <FormItem
                            {...restField}
                            name={[name, "insumoId"]}
                            fieldKey={[arrayKey, "insumoId"]}
                            required
                            noStyle
                        >
                            <SelectInsumosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                disabled
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Insumo"
                                tiposInsumos="inventariables"
                                onChange={(value, insumo) =>
                                    this.onChangeInsumo(value, arrayKey, insumo)
                                }
                                ocultarUnidad
                            />
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                            const insumoSeleccionado = this.state.todasInsumos?.find(
                            (insumo) => insumo._id.toString() === insumoId?.toString()
                            );
                            return (
                            <div style={{ fontSize: '14px', textAlign: 'center' , color: '#868585'}}>
                                {insumoSeleccionado?.unidad || '-'}
                            </div>
                            );
                        }}
                        </FormItem>
                    </td>
                   
                    {/* Proyecto */}
                    <td className="td-border">
                        <FormItem
                            {...restField}
                            name={[name, "proyectoId"]}
                            fieldKey={[arrayKey, "proyectoId"]}
                            required
                            noStyle
                        >
                            <SelectItem
                                sinBorde
                                disabled
                                style={{ width: "100%" }}
                                placeholder="Proyecto"
                            >
                                {this.state.objetoProyectos}
                            </SelectItem>
                        </FormItem>
                    </td>
                  
                    {/* Cantidad */}
                    <td className="td-border">
                        <FormItem
                            {...restField}
                            name={[name, "cantidad"]}
                            fieldKey={[arrayKey, "cantidad"]}
                            required
                            number
                            noStyle
                        >
                            <InputNumberItem
                                sinBorde
                                disabled
                                placeholder="Cantidad"
                            />
                        </FormItem>
                    </td>
                    {/* Accion */}
                    <td className="td-border-sin-right">
                        <Row className="acciones-container">
                            <Col span={24}>
                                <FormItem noStyle shouldUpdate>
                                    {({ getFieldValue }) => {
                                        let arrayValue = getFieldValue("insumos");
                                        let mostrarMarbetes = false;
                                        let mostrarLotes = false;
                                        if (arrayValue[arrayKey]?.insumoId) {
                                            const insumo = this.state.todasInsumos.find(
                                                (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                            );
                                            mostrarMarbetes = insumo?.marbetes;
                                            mostrarLotes = insumo?.lotesCaducidades;
                                        }
                                        return (
                                            <Space
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    alignItems: "center"
                                                }}
                                                size={4}
                                                className="acciones-container"
                                            >
                                                {mostrarLotes && (
                                                    <Tooltip title={this.props.taxidermia ? 'Animales' : 'Lotes'} placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                                                        <ButtonItem
                                                            type="primary"
                                                            size="small"
                                                            cyan2
                                                            icon={<DatabaseOutlined />}
                                                            onClick={() => {
                                                                this.abrirVerLotes(arrayKey, arrayValue[arrayKey]?.insumoId);
                                                            }}
                                                        >
                                                            {this.props.taxidermia ? 'Animales' : 'Lotes'}
                                                        </ButtonItem>
                                                    </Tooltip>
                                                )}
                                                {mostrarMarbetes && (
                                                    <Tooltip title="Marbetes" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                                                        <ButtonItem
                                                            type="primary"
                                                            size="small"
                                                            amarillo2
                                                            icon={<TagsOutlined />}
                                                            disabled
                                                            onClick={() => {
                                                                this.abrirAgregarMarbetes(arrayKey, arrayValue[arrayKey]?.marbetes);
                                                            }}
                                                        >
                                                            Marbetes
                                                        </ButtonItem>
                                                    </Tooltip>
                                                )}
                                            </Space>
                                        );
                                    }}
                                </FormItem>
                            </Col>
                        </Row>
                    </td>
                </tr>
            </React.Fragment>
        );
    }

    render() {
        const isMobile = window.innerWidth < 1000;
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Ver Orden de Comodato"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div className="card-background">
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="verOrdenDeComodato"
                            layout
                            onFinish={(values) => this.setState({ modalConfirmacion: true, valuesForm: values })}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <GeneralFormLayout
                                isMobile={isMobile}
                                cards={[
                                    {
                                        title: "Datos Generales",
                                        lg: 13,
                                        content: (
                                            <>
                                                <Row>
                                                    <Col span={18} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Tipo" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} margin>
                                                            <Radio.Group value={this.state.tipoEntidad} disabled buttonStyle="solid">
                                                                <Radio.Button value="cliente">Cliente</Radio.Button>
                                                                <Radio.Button value="proveedor">Proveedor</Radio.Button>
                                                            </Radio.Group>
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                                {this.state.tipoEntidad === 'cliente' ? (
                                                <Row>
                                                    <Col span={18} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Cliente" name="clienteId" margin required labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                                            <SelectItem placeholder="Cliente" disabled>
                                                                {this.state.objetoClientes}
                                                            </SelectItem>
                                                        </FormItem>
                                                    </Col>
                                                    <Col span={6} style={{ textAlign: 'center', justifyContent: 'center' }}>
                                                        <FormItem shouldUpdate noStyle>
                                                            {({ getFieldValue }) => {
                                                                const clienteId = getFieldValue("clienteId");
                                                                if (!clienteId) return null;
                                                                const cliente = this.state.todasClientes?.find((v) => v._id === clienteId);
                                                                if (!cliente) return null;
                                                                return (
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <p style={{ margin: 0 }}>
                                                                            RFC:{" "}
                                                                            <Tag color="default" style={{ fontWeight: "bold" }}>
                                                                                {cliente.rfc}
                                                                            </Tag>
                                                                        </p>
                                                                    </div>
                                                                );
                                                            }}
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                                ) : (
                                                <Row>
                                                    <Col span={18} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Proveedor" name="proveedorId" margin required labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                                            <SelectItem placeholder="Proveedor" disabled>
                                                                {this.state.objetoProveedores}
                                                            </SelectItem>
                                                        </FormItem>
                                                    </Col>
                                                    <Col span={6} style={{ textAlign: 'center', justifyContent: 'center' }}>
                                                        <FormItem shouldUpdate noStyle>
                                                            {({ getFieldValue }) => {
                                                                const proveedorId = getFieldValue("proveedorId");
                                                                if (!proveedorId) return null;
                                                                const proveedor = this.state.todasProveedores?.find((v) => v._id === proveedorId);
                                                                if (!proveedor) return null;
                                                                return (
                                                                    <div style={{ textAlign: "center" }}>
                                                                        <p style={{ margin: 0 }}>
                                                                            RFC:{" "}
                                                                            <Tag color="default" style={{ fontWeight: "bold" }}>
                                                                                {proveedor.rfc}
                                                                            </Tag>
                                                                        </p>
                                                                    </div>
                                                                );
                                                            }}
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                                )}
                                                <Row>
                                                    <Col span={24} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Proyecto" name="proyectoId" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} margin required>
                                                            <SelectItem placeholder="Proyecto" disabled onChange={(value) => this.onChangeProyecto(value)}>
                                                                {this.state.objetoProyectos}
                                                            </SelectItem>
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={24} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Remisión" name="remision" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} margin pattern max={100}>
                                                            <InputItem disabled placeholder="Remisión del proveedor" />
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col span={24} xs={24} sm={24} lg={18} xl={18}>
                                                        <FormItem label="Observaciones" name="observaciones" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} margin pattern max={500}>
                                                            <TextAreaItem disabled placeholder="Observaciones generales" autoSize={{ minRows: 2, maxRows: 4 }} />
                                                        </FormItem>
                                                    </Col>
                                                </Row>
                                            </>
                                        ),
                                    },
                                    {
                                        title: "Fechas",
                                        lg: 11,
                                      content: (
                                        <>
                                            <Row gutter={16}>
                                            <Col span={12}>
                                                <FormItem
                                                label="Fecha de Orden"
                                                name="fechaOrden"
                                                required
                                                margin
                                                labelCol={{ span: 13 }}
                                                wrapperCol={{ span: 11 }}
                                                >
                                                <DatePickerItem
                                                    placeholder="Fecha de Orden"
                                                    allowClear={false}
                                                    disabled
                                                    disabledDate={(current) =>
                                                    current && current > moment().endOf("day")
                                                    }
                                                />
                                                </FormItem>
                                            </Col>

                                            {!this.props.taxidermia && (
                                                <Col span={12}>
                                                <FormItem
                                                    label="Fecha de Entrega"
                                                    name="fechaEntrega"
                                                    margin
                                                    labelCol={{ span: 13 }}
                                                    wrapperCol={{ span: 11 }}
                                                >
                                                    <DatePickerItem
                                                    placeholder="Fecha de Entrega"
                                                    disabled
                                                    allowClear={false}
                                                    disabledDate={(current) =>
                                                        current && current < moment().startOf("day")
                                                    }
                                                    />
                                                </FormItem>
                                                </Col>
                                            )}
                                            </Row>

                                            <Row>
                                            <Col span={24}>
                                                <FormItem
                                                name={"archivos"}
                                                fieldKey={"archivos"}
                                                margin
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    width: "100%",
                                                }}
                                                >
                                                <Upload
                                                    accept=".pdf"
                                                    showUploadList={{
                                                    showRemoveIcon: true,
                                                    showPreviewIcon: true,
                                                    previewIcon: <EyeOutlined style={{ color: "#1890ff" }} />,
                                                    removeIcon: <DeleteOutlined style={{ color: "red" }} />,
                                                    }}
                                                    fileList={this.state.archivos || []}
                                                    onPreview={this.handlePreviewArchivo.bind(this)}
                                                    disabled
                                                >
                                                    {this.state.archivos?.length >=
                                                    (this.props.taxidermia ? 5 : 3) ? null : (
                                                    <ButtonItem
                                                        blanco
                                                        disabled
                                                        icon={<UploadOutlined />}
                                                        style={{ padding: "0px 20px" }}
                                                    >
                                                        Archivos
                                                    </ButtonItem>
                                                    )}
                                                </Upload>
                                                </FormItem>
                                            </Col>
                                            </Row>
                                        </>
                                        )
                                    },
                                ]}
                                tabsConfig={{
                                    tabs: [
                                        {
                                            key: "insumos",
                                            label: "Insumos",
                                            listName: "insumos",
                                            columns: this.getInsumosColumns(),
                                            renderRow: this.renderInsumoRow.bind(this),
                                        },
                                    ],
                                }}
                                actionButtons={
                                    <>
                                        <ButtonItem
                                            type="primary"
                                            cyanB
                                            hotkey="shift+c"
                                            onClick={() => this.abrirMandarCorreo()}
                                        >
                                            Ver Orden de Comodato
                                        </ButtonItem>
                                        <ButtonItem
                                            type="primary"
                                            rojoB
                                            hotkey="shift+r"
                                            onClick={() => this.atras()}
                                        >
                                            Regresar
                                        </ButtonItem>
                                    </>
                                }
                            />
                        </Form>
                    </Spin>
                </div>
                <ElegirTipoDeCliente
                    visible={this.state.modalElegirTipoDeCliente}
                    id={this.state.modalElegirTipoDeClienteId}
                    nombre={this.state.modalElegirTipoDeClienteNombre}
                    cerrarElegirTipoDeCliente={this.cerrarElegirTipoDeCliente.bind(this)}
                />
                <AgregarMarbetes
                    visible={this.state.modalAgregarMarbetes}
                    cerrarAgregarMarbetes={this.cerrarAgregarMarbetes.bind(this)}
                    marbetes={this.state.modalAgregarMarbetesMarbetes}
                />
                <VerLotes
                    visible={this.state.modalVerLotes}
                    cerrarVerLotes={this.cerrarVerLotes.bind(this)}
                    insumoId={this.state.modalVerLotesInsumoId}
                    indexComodato={this.state.modalVerLotesIndex}
                    comodatoId={this.state.id}
                />
                <MandarCorreoComodato
                    visible={this.state.modalMandarCorreoComodato}
                    id={this.state.id}
                    cerrarMandarCorreoComodato={this.cerrarMandarCorreoComodato.bind(this)}
                />
                <ModalItem
                    visible={this.state.previewVisibleArchivo}
                    title={this.state.previewTitleArchivo}
                    footer={null}
                    onCancel={this.handleCancelArchivo}
                    spinning={false}
                >
                    <iframe
                        src={this.state.previewImageArchivo}
                        title="Vista previa PDF"
                        style={{ width: '100%', height: '80vh', border: 'none' }}
                    />
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
    };
};

export default connect(mapStateToProps)(VerOrdenComodato);